"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabelProps = exports.getDataProvidesProps = exports.Z_INDEX_MAP = void 0;
var getDataProvidesProps = exports.getDataProvidesProps = function getDataProvidesProps(props) {
  var transform = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (string) {
    return string;
  };
  var dataProvidesProps = {};
  if (props['data-provides']) {
    dataProvidesProps['data-provides'] = transform(props['data-provides']);
  }
  if (props['data-provides-of']) {
    dataProvidesProps['data-provides-of'] = transform(props['data-provides-of']);
  }
  if (props['data-provides-for']) {
    dataProvidesProps['data-provides-for'] = transform(props['data-provides-for']);
  }
  return dataProvidesProps;
};
var Z_INDEX_MAP = exports.Z_INDEX_MAP = {
  toggleInput: 100,
  flyout: 200,
  modal: 200,
  datePicker: 300,
  expandableMenu: 300,
  hamburgerMenu: 300,
  tooltip: 300,
  header: 999,
  flashMessage: 1100
};
var getLabelProps = exports.getLabelProps = function getLabelProps(props) {
  var label = props.label,
    ariaLabel = props.ariaLabel,
    ariaLabelledBy = props.ariaLabelledBy;
  if (label) {
    var labelProps = {
      label: label
    };
    if (ariaLabel) {
      labelProps.ariaLabel = ariaLabel;
    }
    if (ariaLabelledBy) {
      labelProps.ariaLabelledBy = ariaLabelledBy;
    }
    if (props.labelIcons) {
      labelProps.labelIcons = props.labelIcons;
    }
    return labelProps;
  }
  if (!label) {
    if (ariaLabel) {
      var _labelProps = {
        ariaLabel: ariaLabel
      };
      if (ariaLabelledBy) {
        _labelProps.ariaLabelledBy = ariaLabelledBy;
      }
      return _labelProps;
    }
    if (ariaLabelledBy) {
      var _labelProps2 = {
        ariaLabelledBy: ariaLabelledBy
      };
      return _labelProps2;
    }
  }
  console.warn('LabelProps must have a label, ariaLabel, or ariaLabelledBy prop');
  return {};
};